import AlignBoxMiddleCenter16 from '@carbon/icons-react/es/align-box--middle-center/16';
import Bullhorn16 from '@carbon/icons-react/es/bullhorn/16';
import Carbon16 from '@carbon/icons-react/es/carbon/16';
import Catalog16 from '@carbon/icons-react/es/catalog/16';
import Chat16 from '@carbon/icons-react/es/chat/16';
import Dashboard16 from '@carbon/icons-react/es/dashboard/16';
import Departure16 from '@carbon/icons-react/es/departure/16';
import Folders16 from '@carbon/icons-react/es/folders/16';
import Money16 from '@carbon/icons-react/es/money/16';
import Workspace16 from '@carbon/icons-react/es/workspace/16';
import { ProjectId } from 'api/models';
import { ClassNameOnlyProps } from 'components/ozone-component';
import { PermissionRuleName } from 'constant';

export enum ProjectDetailTabKeys {
  Overview = 'Overview',
  Financials = 'Financials',
  Plan = 'Plan',
  Spaces = 'Spaces',
  Chat = 'Chat',
  TaskList = 'TaskList',
  TaskBoard = 'TaskBoard',
  StatusUpdate = 'StatusUpdate',
  FormResponses = 'FormResponses',
  Files = 'Files',
}

export interface ProjectDetailTabPropTypes extends ClassNameOnlyProps {
  projectId: ProjectId;
  activeTabKey?: ProjectDetailTabKeys;
}

const projectTabIconMap = {
  [ProjectDetailTabKeys.Overview]: Dashboard16,
  [ProjectDetailTabKeys.Financials]: Money16,
  [ProjectDetailTabKeys.Plan]: Departure16,
  [ProjectDetailTabKeys.Spaces]: Carbon16,
  [ProjectDetailTabKeys.Chat]: Chat16,
  [ProjectDetailTabKeys.StatusUpdate]: Bullhorn16,
  [ProjectDetailTabKeys.TaskList]: Catalog16,
  [ProjectDetailTabKeys.TaskBoard]: Workspace16,
  [ProjectDetailTabKeys.FormResponses]: AlignBoxMiddleCenter16,
  [ProjectDetailTabKeys.Files]: Folders16,
};

export const tabApiEnumMap = {
  [ProjectDetailTabKeys.Overview]: 'overview',
  [ProjectDetailTabKeys.Financials]: 'financials',
  [ProjectDetailTabKeys.Plan]: 'projectPlan',
  [ProjectDetailTabKeys.Spaces]: 'spaces',
  [ProjectDetailTabKeys.Chat]: 'chat',
  [ProjectDetailTabKeys.StatusUpdate]: 'statusUpdates',
  [ProjectDetailTabKeys.TaskList]: 'list',
  [ProjectDetailTabKeys.TaskBoard]: 'board',
  [ProjectDetailTabKeys.FormResponses]: 'form',
  [ProjectDetailTabKeys.Files]: 'files',
};

const tabRuleNameMap = {
  [ProjectDetailTabKeys.Overview]: PermissionRuleName.ProjectOverviewPage,
  [ProjectDetailTabKeys.Plan]: PermissionRuleName.ProjectPlanPage,
  [ProjectDetailTabKeys.Spaces]: PermissionRuleName.ProjectSpacesPage,
  [ProjectDetailTabKeys.FormResponses]:
    PermissionRuleName.ProjectFormResponsePage,
  [ProjectDetailTabKeys.StatusUpdate]:
    PermissionRuleName.ProjectStatusUpdatePage,
};

export const PROJECT_TABS = Object.values(ProjectDetailTabKeys).map((key) => {
  return {
    id: key,
    translationKey: `projects.tabs.${key.toLowerCase()}`,
    icon: projectTabIconMap[key],
    ruleName: tabRuleNameMap[key],
  };
});
